import { DEPLOY_ENV } from 'components/globals';

/**
 * Base URL of the Rails web app that owns the public listings API. Deliberately
 * not RAILS_URL: these server-side fetches always target a deployed backend,
 * even in localdev where RAILS_URL points at a local web instance.
 */
export const WEB_BASE =
  DEPLOY_ENV === 'production' ? 'https://www.opendoor.com' : 'https://demo.simplersell.com';
